import { View } from 'react-native'
import cn from '@ui/utils/cn'
import Typography from '@ui/typography'
import FormattedText from '@ui/typography/FormattedText'
import Button from '@ui/buttons/Button'

import Modal from './Modal'
import { ModalButtons } from './ModalButtons'
import { ModalCardComponentProps, ModalCardProps } from './types'

interface Props extends ModalCardProps, ModalCardComponentProps {
  CardComponent: React.ComponentType<ModalCardComponentProps>
  children: React.ReactNode
}

export default function ModalCard({
  open,
  close,
  children,
  title,
  desc,
  body,
  buttons,
  hideBottomSpace,
  compact,
  intensity = 100,
  center,
  modalProps,
  CardComponent,
  cardComponentProps,
  showClose,
  disableScroll,
  spacedText,
  childrenOutside,
}: Props) {
  return (
    <Modal
      enabled={open}
      onClose={close}
      intensity={intensity}
      backdropClose={close !== undefined}
      {...modalProps}
    >
      <CardComponent
        {...cardComponentProps}
        disableScroll={disableScroll}
        close={close}
        open={open}
      >
        {(title || desc) && (
          <View
            className={cn(
              'gap-2 px-16',
              compact ? 'py-10 pb-8' : 'py-12',
              center && 'items-center',
              spacedText && 'gap-4'
            )}
          >
            {title && (
              <View className="flex-row items-center justify-between">
                <Typography
                  variant={compact ? 'LGB' : 'XLB'}
                  className={cn(center && 'text-center')}
                >
                  {title}
                </Typography>
              </View>
            )}
            {desc && (
              <FormattedText
                variant={compact ? 'SM' : 'MD'}
                className={cn('color-desc', center && 'text-center')}
                classNameBold="color-text"
                text={desc}
              />
            )}
          </View>
        )}
        {body}
        {buttons && <ModalButtons>{buttons}</ModalButtons>}
        {children}
        {!hideBottomSpace && !buttons && (
          <View className={cn(compact ? 'h-8' : 'h-16')} />
        )}
        {showClose && !!close && (
          <View className="absolute right-8 top-8 rounded-full bg-white">
            <Button
              variant="outlined"
              size="sm"
              iconStart="x"
              onPress={close}
            />
          </View>
        )}
      </CardComponent>
      {childrenOutside}
    </Modal>
  )
}
